import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { AUTOMATION_TRANSACTIONS } from './actions';
import { IMPORT_STATS_TABLE } from 'cargo-chief-commons';

export const reducers = createReducer(
	initialState,
	on(AUTOMATION_TRANSACTIONS.TRANSACTIONS_LIST.GET, (state) => ({ ...state, loading: true })),
	on(AUTOMATION_TRANSACTIONS.TRANSACTIONS_LIST.SUCCESS, (state, action) => ({
		...state,
		loading: false,
		transactionsList: IMPORT_STATS_TABLE(action.content, state.activeUsersList),
		total: action.totalElements,
	})),
	on(AUTOMATION_TRANSACTIONS.TRANSACTIONS_LIST.FAILURE, (state, action) => ({
		...state,
		loading: false,
	})),
	on(AUTOMATION_TRANSACTIONS.USERS_LIST.SET, (state, action) => ({
		...state,
		activeUsersList: action.usersList,
	})),

	on(AUTOMATION_TRANSACTIONS.STATS.TRANSACTIONS_COUNT.SUCCESS, (state, action) => ({
		...state,
		totalTransactions: action.data,
	})),
	on(AUTOMATION_TRANSACTIONS.STATS.THIS_MONTH.SUCCESS, (state, action) => ({
		...state,
		transactionsThisMonth: action.data,
	})),
	on(AUTOMATION_TRANSACTIONS.STATS.PRICING.SUCCESS, (state, action) => ({
		...state,
		transactionsUsedForPricing: action.data,
	}))
);
